import { render, staticRenderFns } from "./SoftwareSupportDetail.vue?vue&type=template&id=e5e9a800&scoped=true"
import script from "./SoftwareSupportDetail.vue?vue&type=script&lang=js"
export * from "./SoftwareSupportDetail.vue?vue&type=script&lang=js"
import style0 from "./SoftwareSupportDetail.vue?vue&type=style&index=0&id=e5e9a800&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e9a800",
  null
  
)

export default component.exports